module.exports = __webpack_public_path__ + "img/login_biaoti6.0b9c503d.png";